<template>
  <div>
    <span
      v-if="!data.item.is_completed"
      class="hover-pointer"
      @click="completeInternalAudit(data.item.id)"
    >❌</span>
    <span v-else>
      <feather-icon
        icon="CheckIcon"
        class="cursor-none"
        size="25"
        color="success"
      />
    </span>
  </div>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    getAllData: {
      type: Function,
      required: true,
    },
  },
  methods: {
    completeInternalAudit(id) {
      this.$swal({
        title: 'Are you sure you want to complete this Internal Audit?',
        width: 600,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Approve',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
      }).then(result => {
        if (result.isConfirmed) {
          axios.patch(`internal-audit/${id}/mark-as-completed`)
            .then(() => {
              this.$toast.success('Approved Successfully!')
              this.getAllData()
            })
            .catch(error => {
              const payload = decryptData(error.response.data.payload).message
              const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
              const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMessage,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            })
        }
      })
    },
  },
}
</script>
